export default __webpack_public_path__ + "static/media/windows_process_metrics.b9322b65.md";